import React from "react"
import styled from "styled-components"

import Profile from "../components/Profile"
import redProfile from "../images/RedProfile.jpg"


const StyledProfile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`


const ProfileView = () => {
  return (
    <StyledProfile>
      <Profile 
        name="Zabir Red Nur"
        job="Software Developer"
        pronunciation="zuh-BEER red ner"
        photo={redProfile}
        email="rednur01 [at] gmail"
        />
    </StyledProfile>
  )
  }

export default ProfileView